<script setup lang="ts">
  import { computed, watch } from 'vue';
  import { useStore } from 'vuex';
  import { AppGetters } from '@store/App/getters';

  import { useHideMobileHeader } from '@/composables/useHideMobileHeader';
  import { META_THEME_COLOR } from '@/consts/skins.const';
  import { AppActions } from './store/App/actions';

  const { dispatch, getters } = useStore();

  dispatch(AppActions.GetBrand);
  const brand = computed(() => getters[AppGetters.GetBrand]);

  const displayProgressBarColor = useHideMobileHeader();
  const colorVariables = computed(() => META_THEME_COLOR[brand.value]);
  const mobileMetaContentColor = computed(() => (displayProgressBarColor.value ? colorVariables.value.secondary : colorVariables.value.primary));

  watch(mobileMetaContentColor, (newColor) => document.querySelector('meta[name="theme-color"]')?.setAttribute('content', newColor), { immediate: true });
</script>

<template>
  <RouterView :class="`theme-${brand}`" />
</template>

<style lang="scss">
  @import '@/style/index';
  @import '@/style/variables';

  $mobile_background: (
    default: url('#{$imagesPath}default_mobile_bg.png'),
    europcar: url('#{$imagesPath}europcar_mobile_bg.png'),
  );
  $desktop_background: (
    default: url('#{$imagesPath}default_desktop_bg.png'),
    europcar: url('#{$imagesPath}europcar_desktop_bg.png'),
  );

  $mobile_bg_default: map-get($mobile_background, default);
  $mobile_bg_europcar: map-get($mobile_background, europcar);
  $desktop_bg_default: map-get($desktop_background, default);
  $desktop_bg_europcar: map-get($desktop_background, europcar);

  #app {
    position: relative;
    width: 100%;

    .theme {
      &-keyngo,
      &-goldcar {
        background-image: $mobile_bg_default;
        background-repeat: no-repeat;
        background-position: center bottom 10%;
        background-size: $tablet-portrait;

        @media (min-width: $tablet-portrait) {
          background-image: $desktop_bg_default;
          background-position: center bottom;
          background-size: $desktop;
        }
      }

      &-europcar {
        background-image: $mobile_bg_europcar;
        background-repeat: no-repeat;
        background-position-x: center;

        @media (min-width: $tablet-portrait) {
          background-image: $desktop_bg_europcar;
          background-size: $desktop;
        }
      }
    }
  }
</style>
